export class Microsoft365TeamsRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "newChannelName",
            "baseName": "newChannelName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365TeamsRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
